export default {
    consumer: 10,
    backoffice: 11
};
